const instance = {
  baseURL: 'https://elementcontrol.azurewebsites.net/api/',
  // baseURL: 'http://192.168.15.18:4000/api/'
  // baseURL: 'http://192.168.15.34:4000/api/',
  // baseUrl: 'http://localhost:3002/api/',
};

export default instance;
